import { BASE_URL,  SERVICES } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IService, IServiceInput } from "models/services";

export async function getServices(params: string = "") : Promise<IService[]> {
  const response = await axios.get(BASE_URL + SERVICES + params);
  return response.data;
}
export async function addService(data: IServiceInput) {
  const response = await axios.post(BASE_URL + SERVICES, data);
  return response.data;
}
export async function editService(data: IServiceInput, id: string) {
  const response = await axios.patch(BASE_URL + SERVICES + "/" + id , data);
  return response.data;
}

export async function deleteService(id: string) {
  const response = await axios.delete(BASE_URL + SERVICES + "/" + id);
  return response.data;
}

export const ServicesCells: HeadCell[] = [
  {
    id: "serviceName",
    numeric: false,
    disablePadding: false,
    label: "Service Name",
  },
  {
    id: "planNames",
    numeric: false,
    disablePadding: false,
    label: "Plans",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];
